"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _form = require("@jsluna/form");

var _constants = require("../utils/constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var NumericAnswer = function NumericAnswer(_ref) {
  var id = _ref.id,
      disabled = _ref.disabled,
      value = _ref.value,
      setValue = _ref.setValue,
      error = _ref.error,
      min = _ref.min,
      max = _ref.max,
      pattern = _ref.pattern;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_form.TextInputField, {
    value: value,
    onChange: function onChange(e) {
      return setValue(e.target.value);
    },
    error: error ? (0, _constants.NUMERIC_ANSWER_TYPE_ERROR)(min, max) : '',
    disabled: disabled,
    name: id + "-NumericInputResponse",
    type: "number",
    min: min,
    max: max,
    pattern: pattern
  }));
};

NumericAnswer.propTypes = {
  /** The unique identifier of the question */
  id: _propTypes.default.string.isRequired,

  /** Indicates whether the component should be disabled */
  disabled: _propTypes.default.bool,

  /** The response value for this component */
  value: _propTypes.default.string,

  /** Function to set the response value for this component */
  setValue: _propTypes.default.func,

  /** Indicates whether there is an error with the given response */
  error: _propTypes.default.bool,

  /** Indicates whether there is an min with the given response */
  min: _propTypes.default.number,

  /** Indicates whether there is an max with the given response */
  max: _propTypes.default.number,

  /** Indicates whether there is an pattern with the given response */
  pattern: _propTypes.default.string
};
NumericAnswer.defaultProps = {
  disabled: false,
  value: '',
  setValue: function setValue() {},
  error: false,
  pattern: ''
};
var _default = NumericAnswer;
exports.default = _default;